import propsTag from '@/js/util/props/propsTag'

function maybeMsCrypto() {
  const { crypto, msCrypto } = window
  // msCyrpto is a fallback method
  // for IE 11 compatibility
  return crypto || msCrypto
}

function getsRandomValues() {
  const unitArray = new Uint32Array(1)
  return maybeMsCrypto().getRandomValues(unitArray)
}

export default {
  provide() {
    // could be a symbol
    // could be named something different
    return { id: this }
  },
  props: {
    ...propsTag,

    dispatch: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    const [randomValues] = getsRandomValues()
    return {
      randomValues,
    }
  },

  render(createElement) {
    const scopedSlot = this.$scopedSlots.default({
      randomId: this.randomValues,
    })

    return createElement(this.tag, this.dispatch ? scopedSlot : this.$slots.default)
  },
}



// WEBPACK FOOTER //
// ./src/js/components/RandomId.js